<script setup>
import { onBeforeUnmount, ref } from 'vue'

import AppModal from '@ui/app-modal/AppModal.vue'

import EventBusV3 from '@/shared/eventBus'
import { CLOSE_CLOUDFLARE_CHALLENGE, SHOW_CLOUDFLARE_CHALLENGE } from '@/shared/eventContract'

// Port of resources/js/components/cloudflare-challenge/CloudflareChallenge.vue
// plus its App.vue host wiring: the axios cloudflare interceptor (both
// bundles) emits show/close on the shared bus; the iframe posts a
// 'gate-passed' message back to the interceptor when the challenge passes.
const isOpen = ref(false)

const show = () => {
  isOpen.value = true
}

const close = () => {
  isOpen.value = false
}

EventBusV3.on(SHOW_CLOUDFLARE_CHALLENGE, show)
EventBusV3.on(CLOSE_CLOUDFLARE_CHALLENGE, close)

onBeforeUnmount(() => {
  EventBusV3.off(SHOW_CLOUDFLARE_CHALLENGE, show)
  EventBusV3.off(CLOSE_CLOUDFLARE_CHALLENGE, close)
})
</script>

<template>
  <app-modal
    v-model="isOpen"
    :close="false"
    :header="false"
    :footer="false"
    :max-width="714"
  >
    <template #body>
      <iframe
        src="/gate/check"
        class="cloudflare-challenge-host-frame"
        title="Cloudflare challenge"
      />
    </template>
  </app-modal>
</template>

<style lang="scss" scoped>
.cloudflare-challenge-host-frame {
  margin: 0;
  width: 100%;
  height: 372px;
  padding: 0;
  border: none;
}
</style>
